export default "__VITE_ASSET__DU0sBx7b__"